import ImageMarquee from './ImageMarquee';

const Secfour = () => {
    return (
        <div className="w-full bg-[#F6F5F1] pt-20 pb-24 px-4 md:px-10 lg:px-16">
            <div className="flex flex-col items-center text-center mb-12">
                <div className="flex items-center gap-2 mb-5">
                    <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                    <span className="text-[#B8862E] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                        Campus
                    </span>
                    <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                </div>
                <h2
                    className="text-3xl md:text-4xl text-[#12213D] leading-tight"
                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                >
                    Our school premises
                </h2>
            </div>

            <ImageMarquee />
        </div>
    )
}
export default Secfour;